import { CommonModule, DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { Column, DynamicFieldModel, DynamicFormComponent, User } from '@share';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';
import { UserService } from './user.service';
import { error } from '@ant-design/icons-angular';
import { ExcelService } from 'src/app/share/services/excel.service';

@Component({
  selector: 'app-user',
  imports: [DynamicTableComponent, NzToolTipModule, NzIconModule, NzDividerModule, NzPopconfirmModule, NzInputModule, NzCardModule, NzTableModule, CommonModule, NzGridModule, FormsModule, NzButtonModule],
  providers: [NzModalService, DatePipe],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent implements OnInit {
  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'User Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },
    {
      label: 'Mobile No.',
      name: 'phone',
      type: 'input',
      placeholder: '',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Phone required',
        },
        {
          name: 'phoneValid',
          validator: 'phoneValidator',
          message: 'Phone invalid',
        },
      ],
    },
    {
      label: 'Gender',
      name: 'gender',
      type: 'select',
      placeholder: 'Select Gender',
      required: false,
      options: [],
    },
    {
      label: 'Region',
      name: 'region',
      type: 'select',
      placeholder: 'Select Region',
      required: false,
      options: [],
    },
    // {
    //   label: 'email',
    //   name: 'email',
    //   type: 'input',
    //   placeholder: '',

    //   required: true,
    //   validations: [
    //     {
    //       name: 'email',
    //       validator: Validators.email,
    //       message: 'Please add valid email',
    //     }
    //   ],
    // },
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      placeholder: '',
      options: [{ text: "active", value: "active" }, { text: "inactive", value: "inactive" }, { text: "banned", value: "banned" }],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Status required',
        },
      ],
    },
    {
      label: 'App Feedback',
      name: 'feedback',
      type: 'quill-text',
      placeholder: '',
      readonly: true,
      required: false,
    },
    {
      label: 'id',
      name: '_id',
      type: 'hidden',
      placeholder: '',
    }
  ];
  listOfData: User[] = [];
  list: any[] = [];
  loading = false;
  total = 0;
  pageSize = 10;
  pageIndex = 1;
  searchValue = '';
  currentTime: Date = new Date();
  private searchSubject = new Subject<string>();

  schema = {
    name: "User List",
    permissionKey: "user",
    enableDelete: false,
    enableEdit: true,
    enableAdd: false,
    enableDownload: false,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "name",
        title: "Name",
        type: "string",
        enableSearch: true,
        searchType: "input",
        enableSort: true,
        isStickyRight: false,
        isStickyLeft: false,

        width: "200px"
      },
      {
        key: "phone",
        title: "Phone",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "genderDisplay.name",
        title: "Gender",
        type: "object",
        enableSearch: true,
        enableSort: true,
        searchType: "select",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
        option: [{ value: '', text: "''" }],
      },
      {
        key: "status",
        title: "Status",
        type: "string",
        enableSearch: true,
        searchType: "select",
        isStickyRight: false,
        isStickyLeft: false,
        option: [{ value: 'active', text: "active" },{ value: 'inactive', text: "inactive" },{ value: 'banned', text: "banned" }],
        width: "150px"
      },
      {
        key: "region",
        title: "Region",
        type: "string",
        enableSearch: true,
        searchType: "select",
        isStickyRight: false,
        isStickyLeft: false,
        option: [{ value: '', text: "''" }],
        width: "200px"
      },
      {
        key: "last_active",
        title: "Last Active",
        type: "date",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "createdAt",
        title: "Created At",
        type: "date",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "feedback",
        title: "App Feedback",
        type: "string",
        enableSearch: false,
        searchType: "input",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "rating",
        title: "App Rating",
        type: "rate",
        enableSearch: false,
        searchType: "input",
        width: "250px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  report = {
    name: "User Report",
    file_name: "User_Report",
    header: [
      {
        label: "No",
        fieldName: "no",
        tag: "no",
        width: 5
      },
      {
        label: "User Id",
        fieldName: "_id",
        class: "align-left",
        width: 30
      },
      {
        label: "Name",
        fieldName: "name",
        class: "align-left",
        width: 30
      },
      {
        label: "Mobile No.",
        fieldName: "phone",
        class: "align-left",
        width: 30
      },
      {
        label: "Status",
        fieldName: "status",
        class: "align-left",
        width: 30
      },
      {
        label: "State/Region",
        fieldName: "region",
        class: "align-left",
        width: 25
      },
      {
        label: "Status",
        fieldName: "status",
        class: "align-left",
        width: 20
      },
      {
        label: "Gender",
        fieldName: "gender.name",
        objFieldName: "gender",
        class: "align-left",
        width: 20
      },
      {
        label: "Created At",
        fieldName: "createdAt",
        tag:"datetime",
        class: "align-left",
        width: 20
      }

    ]
  };

  constructor(private datePipe: DatePipe, private service: UserService, private modalService: NzModalService, private loadingService: LoadingService, private readonly excelService: ExcelService) { }
  ngOnInit(): void {
    // this.searchSubject.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
    //   this.pageIndex = 1; // Reset to first page on search
    //   //this.loadData();
    // });
    this.service.getRegions().subscribe({
      next: (res) => {
        const options = res.data.map((item: any) => ({
          value: item.value,
          text: item.name
        }));
        // Update schema column options
        this.schema.columns[5].option = options;
        // Update form fieldConfig region options
        const regionField = this.fieldConfig.find(field => field.name === 'region');
        if (regionField) regionField.options = options;
      },
      error: (err) => console.error('Error loading regions:', err)
    });


    // Load genders for the form dropdown
    this.service.getGenders().subscribe({
      next: x => {
        const genderField = this.fieldConfig.find(field => field.name === 'gender');
        if (genderField) {
          genderField.options = x.data.map((item: any) => ({
            text: item.name,
            value: item.id
          }));
        }

        // Also update the table schema gender column options for filtering
        const genderColumn = this.schema.columns.find(col => col.key === 'genderDisplay.name');
        if (genderColumn) {
          genderColumn.option = x.data.map((item: any) => ({
            value: item.name,
            text: item.name
          }));
        }
      }, error: err => {
        console.error('Error loading genders:', err);
      }, complete: () => {

      }
    });
    let params = new HttpParams()
      .set('page', this.schema.pageIndex.toString())
      .set('pageSize', this.schema.pageSize.toString());
    this.loadData(params);
  }

  // addUser(): void {
  //     const modalRef: NzModalRef = this.modalService.create({
  //       nzTitle: 'Create Group',
  //       nzContent: DynamicFormComponent,  // Use dynamic form component
  //       nzData: {fields:this.fieldConfig,data:null},
  //       nzFooter: null,
  //       nzMaskClosable: false   // We'll add footer buttons manually
  //     });
  //     modalRef.updateConfig({
  //       nzFooter: [{
  //         label: 'Submit',
  //         type: 'primary',
  //         onClick: () => this.handleSubmit(modalRef)
  //       },
  //       {
  //         label: 'Cancel',
  //         onClick: () => this.handleCancel(modalRef)
  //       }

  //       ]
  //     });
  //   }

  edit(index: number): void {
    const modalRef: NzModalRef = this.modalService.create({
      nzTitle: 'Edit User',
      nzContent: DynamicFormComponent,  // Use dynamic form component
      nzData: { fields: this.fieldConfig, data: this.list[index] },
      nzFooter: null,
      nzMaskClosable: false   // We'll add footer buttons manually
    });
    modalRef.updateConfig({
      nzFooter: [{
        label: 'Update',
        type: 'primary',
        onClick: () => this.handleUpdate(modalRef, index)
      },
      {
        label: 'Cancel',
        onClick: () => this.handleCancel(modalRef)
      }

      ]
    });
  }

  handleCancel(modalRef: NzModalRef): void {
    console.log('Modal closed without submission');
    modalRef.destroy();  // Close the modal
  }

  // Handle Submit button action
  handleSubmit(modalRef: NzModalRef, index: number = -1): void {

    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {
      console.log(component.form.value as FormData);
      let data = component.form.value;
      this.listOfData.push(data);
      console.log(this.listOfData);
      modalRef.destroy();
    } else {
      console.log('Form is invalid');
      component.form.markAllAsTouched();
    }
  }

  handleUpdate(modalRef: NzModalRef, index: number = -1): void {

    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {
      let data = component.form.value;
      if (!data._id && !data.id) {
        console.error('No user ID found in form data');
        return;
      }
      this.listOfData[index] = data;
      console.log(this.listOfData);
      modalRef.destroy();
    } else {
      console.log('Form is invalid');
      component.form.markAllAsTouched();
    }
  }

  change(data: { [key: string]: any }) {
    if (data['type'] == 'download') {
      let params = new HttpParams()
        .set('filterValue', JSON.stringify(data['filters']));
      this.loadingService.toggleTableLoading()
      this.service.getUsers(params).subscribe({
        next: x => {
          //this.list = x.data;
          const data = x.data;
          if (data !== undefined && data.length !== 0) {
            const value = []
            for (let i = 0; i < data?.length; i++) {
              // if (this.report.header.length === 0) {
              //   this.report.header = Object.keys(data[i])
              // }
              const item: any = {}
              for (const row of this.report.header) {
                const head = row
                if (!head.hasOwnProperty('objFieldName')) {
                  if (head.tag === 'no') item[head.label] = i + 1
                  else if (head.tag === 'number')
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : 0
                  else if (head.tag === 'pipe') {
                    const [field1, field2] = head.fieldName.split('|');
                    const value = data[i][field1];
                    item[head.label] = value !== '' && value != null
                      ? value
                      : data[i][field2] ?? '';
                  }
                  else if (head.tag === 'datetime') {
                    item[head.label] = data[i][head.fieldName]
                      ? this.datePipe.transform(new Date(data[i][head.fieldName]),'dd-MM-yyyy HH:mm')
                      : ''
                  }
                  else
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : ''
                } else {
                  item[head.label] =
                    data[i][head.objFieldName] !== null
                      ? this.getCellValue(data[i], head)
                      : ''
                }
              }
              value.push(item)
            }
            const dynamicName = `${this.report.file_name
              }_${this.currentTime.getDate()}_${this.currentTime.getMonth() + 1
              }_${this.currentTime.getFullYear()}`
            this.excelService.exportAsExcelFile(
              value,
              dynamicName,
              this.report.header
            )
          }
        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => this.loadingService.toggleTableLoading()
      });
    }
    else {
      let params = new HttpParams()
        //.set('searchValue',this.searchValue)
        .set('page', data['pageIndex'].toString())
        .set('pageSize', data['pageSize'].toString())
        .set('filterValue', JSON.stringify(data['filters']))
        .set('sort', JSON.stringify(data['sorts']));
      this.loadData(params);
    }
  }

  getCellValue(row: any, column: Column): string {
    if (column.fieldName === "eng_version") {
      if (row[column.fieldName]) {

        return 'mm , en';
      }
      else {
        return 'mm'
      }
    }
    if (!row[column.fieldName.split('.')[0]]) return ''
    const result: string = column.fieldName
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    if (column.pipe) {
      switch (column.pipe) {
        case 'shortDateTime': {
          console.log(this.datePipe.transform(result));
          return this.datePipe.transform(result)
        }
      }
    }

    return result
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading()
    this.service.getUsers(param).subscribe({
      next: x => {
        this.list = x.data.map((user: any) => {
          const transformedUser = { ...user };
          // Handle gender object for display and form
          if (transformedUser.gender?.id || transformedUser.gender?._id) {
            transformedUser.genderDisplay = transformedUser.gender;
            transformedUser.gender = transformedUser.gender.id || transformedUser.gender._id;
            transformedUser.genderSearch = transformedUser.genderDisplay.name;
          }
          return transformedUser;
        });
        this.total = x.totalCount;
      },
      error: err => this.loadingService.toggleTableLoading(),
      complete: () => this.loadingService.toggleTableLoading()
    });
  }

  formEvent(data: any) {
    if (data.id || data._id) {
      const { feedback, ...updateData } = data;
      this.service.updateUser(updateData).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    // else{
    //   this.service.createItem(data).subscribe(x=> {
    //     let params = new HttpParams()
    //     .set('page', this.schema.pageIndex.toString())
    //     .set('pageSize', this.schema.pageSize.toString());
    //     this.loadData(params);
    //   });
    // }

  }
}
